export const RuleWhitelistHelperMessage =
  'On this page you can create and modify whitelists to specify IP addresses and ' +
  'processes that should be considered safe in your infrastructure. These whitelists will ' +
  'affect how rules are triggered and which detections are suppressed'

export const RuleWhitelistTypeMessage = [
  {
    title: 'IP Address Whitelist',
    message:
      'Configure a global list of safe IP addresses. Note: You can create only one IP Whitelist and the list of applicable rules is not editable.'
  },
  {
    title: 'Process Whitelist',
    message:
      'Configure a list of processes that should be considered safe for a selected set of rules'
  }
]



// WEBPACK FOOTER //
// ./src/constants/wizard-helper.constants.js